import { Grid } from '@material-ui/core';
import { Typography } from '@nutrien/cxp-components';
import React from 'react';

import { AreaType, FileType } from '../../utilities/enums';
import { useWindowDimensions } from '../../utilities/useWindowDimensions';
import { downloadFile } from '../../utilities/utilityFunctions';
import useStyles from '../AssetLocationDetails/AssetLocationDetails.styles';
import { Area, FileArea } from '../model/model';
interface Props {
  areaProperties: Area;
  areaType: string;
  parentName: string;
  assetCategory: { assetMainCategory?: string; assetSubCategory?: string };
}

const ShaftAreaProperties = ({
  areaProperties,
  areaType = AreaType.MainArea,
  parentName,
  assetCategory,
}: Props) => {
  const size = useWindowDimensions();
  const classes = useStyles({ size });
  const Fields = [
    'parentName',
    'areaType',
    'name',
    'pcsId',
    'layout',
    'floorLevel',
    'lowBound',
    'upperBound',
  ];
  const Label = [
    'Parent Area',
    'Area Type',
    'Area Name',
    `${areaType} ID`,
    `${areaType} Layout`,
    'Floor Level',
    'Lower Bound',
    'Upper Bound',
  ];
  const subAreaLabel = [
    'Asset Category',
    'Asset Sub Category',
    'AIMS Asset ID',
    'eAM ID',
    'AIMS Asset Name',
    'Asset Description',
  ];
  const subAreaFields = [
    'assetMainCategory',
    'assetSubCategory',
    'assetId',
    'eAMId',
    'assetName',
    'assetDescription',
  ];
  const subAreaFilesLabel = ['Asset Drawings', 'Layout', 'Asset Pictures'];
  const subAreaFilesFields = ['Drawings', 'Layout', 'Pictures'];
  const assetCategoryList = ['Asset Category', 'Asset Sub Category'];

  if (areaType === AreaType.SubArea) {
    Label.splice(5, 0, ...subAreaLabel);
    Fields.splice(5, 0, ...subAreaFields);
    Label.splice(Label.length, 0, ...subAreaFilesLabel);
    Fields.splice(Fields.length, 0, ...subAreaFilesFields);
  }

  const getFilesView = (fileType: number) => {
    const files = areaProperties.fileArea.filter(
      (file: FileArea) => file.fkDrawingType === fileType,
    );
    if (files && files.length) {
      return files.map((file: FileArea) => {
        return (
          <Typography
            key={file.fkFileAims}
            variant="subtitle1"
            fontWeight="normal"
            onClick={() => downloadFile(file.fkFileAims)}
          >
            {file.name}
          </Typography>
        );
      });
    }
    return '-';
  };

  const getFieldName = (index: number) => {
    switch (index) {
      case 0:
        return parentName;
      case 1:
        return areaType;
      case 4:
        return getFilesView(FileType.AreaLayout);
      case 14:
        return getFilesView(FileType.Drawings);
      case 15:
        return getFilesView(FileType.Layout);
      case 16:
        return getFilesView(FileType.Pictures);
      default:
        return areaProperties[Fields[index] as keyof Area] || '-';
    }
  };

  const getLabelValue = (label: string) => {
    switch (label) {
      case 'Asset Category':
        return assetCategory?.assetMainCategory || assetCategory?.assetSubCategory || '-';
      case 'Asset Sub Category':
        return assetCategory?.assetMainCategory ? assetCategory?.assetSubCategory || '-' : '-';
      default:
        return '-';
    }
  };

  return (
    <>
      {areaProperties &&
        Label.map((label: string, index: number) => {
          return (
            <Grid item container xs={12} className={classes.assetProperties} key={label}>
              <Grid item xs={12} className={classes.innerBlock}>
                <Grid item xs={5}>
                  <Typography variant="subtitle1" color="textSecondary" fontWeight="normal">
                    {label}
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography variant="subtitle1" fontWeight="normal">
                    {assetCategoryList.includes(label) ? getLabelValue(label) : getFieldName(index)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          );
        })}
    </>
  );
};

export default ShaftAreaProperties;
